import {DeepPartial} from 'react-hook-form';

import {useLazyGetDirectSaleLabourItemCalculatePriceQuery} from '@dms/api/warehouse';

import {EditLabourItemForm} from '../../../../../types/EditLabourItemForm';
import {buildCalculatePriceBody} from '../utils/buildCalculatePriceBody';

interface UseRecalculateLabourItemPriceParams {
  directSaleId: string;
  itemId: string;
}

interface RecalculateOverrides {
  workType?: string;
}

/**
 * Imperatively recalculates a labour item's price via the calculate-price
 * endpoint with `getCurrentPrice: true`. Returns the lazy query trigger so
 * callers unwrap and apply the result themselves (via
 * `mapToLabourItemCurrentPrices`).
 */
export function useRecalculateLabourItemPrice(params: UseRecalculateLabourItemPriceParams) {
  const [calculatePrice, calculatePriceQuery] = useLazyGetDirectSaleLabourItemCalculatePriceQuery();

  const recalculate = (
    formValues: DeepPartial<EditLabourItemForm>,
    overrides?: RecalculateOverrides
  ) =>
    calculatePrice({
      directSaleId: params.directSaleId,
      itemId: params.itemId,
      body: buildCalculatePriceBody(formValues, {
        getCurrentPrice: true,
        workType: overrides?.workType,
      }),
    });

  return {recalculate, isLoading: calculatePriceQuery.isLoading};
}
